// Generated by tools/landing-prototypes/source/pano4.py - do not hand-edit.
// Screen-space geometry for the Wasdale hero, in the 2400 x 1300 coordinate
// space of public/images/landing/wasdale-*.webp. Each point is
// [x, y, layer], where layer indexes HERO_LAYERS (0 = farthest).

export type HeroPoint = readonly [x: number, y: number, layer: number];

export const HERO_IMAGE_WIDTH = 2400;
export const HERO_IMAGE_HEIGHT = 1300;

/** Scafell Pike -> Lingmell -> Wasdale Head, projected from the terrain. */
export const HERO_MAIN_ROUTE: readonly HeroPoint[] = [
  [2081, 336, 1],
  [2055, 346, 1],
  [2029, 360, 1],
  [2004, 385, 1],
  [1979, 394, 1],
  [1954, 413, 1],
  [1929, 438, 1],
  [1904, 454, 1],
  [1879, 468, 1],
  [1853, 477, 1],
  [1827, 490, 1],
  [1801, 491, 1],
  [1774, 485, 1],
  [1747, 469, 1],
  [1721, 469, 1],
  [1694, 458, 1],
  [1667, 452, 1],
  [1653, 444, 1],
  [1639, 453, 1],
  [1624, 452, 1],
  [1609, 457, 1],
  [1593, 460, 1],
  [1578, 474, 1],
  [1561, 461, 1],
  [1545, 474, 1],
  [1538, 464, 1],
  [1530, 478, 2],
  [1523, 493, 2],
  [1515, 504, 2],
  [1507, 499, 2],
  [1499, 510, 2],
  [1490, 523, 2],
  [1482, 558, 2],
  [1473, 613, 2],
  [1463, 658, 2],
  [1454, 704, 2],
  [1444, 740, 2],
  [1433, 761, 2],
  [1422, 790, 2],
  [1411, 809, 2],
  [1399, 828, 2],
  [1371, 848, 2],
  [1341, 854, 2],
  [1312, 858, 2],
  [1281, 861, 2],
  [1251, 864, 2],
  [1219, 867, 2],
  [1187, 868, 2],
  [1155, 870, 2],
];

/** Great Gable down to the valley, where it meets the main route. */
export const HERO_GABLE_ROUTE: readonly HeroPoint[] = [
  [1054, 482, 0],
  [1052, 487, 1],
  [1050, 498, 1],
  [1049, 511, 1],
  [1047, 533, 1],
  [1046, 539, 1],
  [1044, 560, 1],
  [1042, 592, 1],
  [1040, 609, 1],
  [1045, 634, 1],
  [1050, 674, 1],
  [1055, 697, 1],
  [1061, 734, 1],
  [1066, 756, 1],
  [1072, 785, 1],
  [1078, 802, 1],
  [1084, 812, 1],
  [1090, 815, 1],
  [1097, 811, 1],
  [1104, 808, 1],
  [1111, 807, 1],
  [1119, 796, 2],
  [1127, 802, 2],
  [1135, 806, 2],
  [1144, 815, 2],
  [1155, 817, 2],
  [1166, 822, 2],
  [1178, 824, 2],
  [1190, 830, 2],
  [1202, 836, 2],
  [1215, 841, 2],
  [1228, 846, 2],
  [1241, 850, 2],
  [1260, 849, 2],
  [1278, 846, 2],
  [1298, 844, 2],
  [1317, 842, 2],
  [1337, 842, 2],
  [1357, 839, 2],
  [1378, 832, 2],
  [1399, 828, 2],
];

/** Hand-placed continuation along the north-west shore of Wast Water. */
export const HERO_SHORE_ROUTE: readonly HeroPoint[] = [
  [1000, 882, 2],
  [860, 892, 2],
  [745, 916, 3],
  [665, 968, 3],
  [612, 1050, 4],
  [562, 1150, 4],
  [505, 1262, 4],
  [470, 1345, 4],
  [440, 1430, 4],
];

export interface HeroPin {
  name: string;
  /** Height in metres. */
  height: number;
  collected: boolean;
  /** Whether the name and height pill is shown beside the pin. */
  labelled: boolean;
  /** Seconds after load before the pin appears. */
  delay: number;
  at: HeroPoint;
}

export const HERO_PINS: readonly HeroPin[] = [
  { name: "Scafell Pike", height: 978, collected: true, labelled: true, delay: 1.4, at: [2081, 327, 1] },
  { name: "Lingmell", height: 807, collected: true, labelled: false, delay: 2.1, at: [1667, 447, 1] },
  { name: "Great Gable", height: 899, collected: true, labelled: true, delay: 2.5, at: [1054, 476, 0] },
  { name: "Kirk Fell", height: 802, collected: false, labelled: false, delay: 3.8, at: [711, 479, 1] },
  { name: "Yewbarrow", height: 629, collected: false, labelled: false, delay: 4, at: [410, 353, 2] },
];
